<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01">“Of course you appropriated me—but too much.”</p>
<p class="fm-02">—Wolfgang Amadeus Mozart</p>
<p class="fm-02">in a letter to his father, Leopold</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?0273783e